



import { Cookies } from 'react-cookie'
// ** Store Imports
import { useDispatch, useSelector } from 'react-redux'

 const useUserAuth = () => {
  // ** Hooks

  const isLogin = useSelector(state => state.auth?.isLogin)
  const cookies = new Cookies();
   const token = cookies.get(process.env.REACT_APP_TOKEN_NAME || 'back_office_t',{path:'/'});
 
  return !!token && !!isLogin
}
export default useUserAuth; 